<template>
  <div class="min-h-screen bg-gray-50">
    <div class="bg-white shadow">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center gap-3 py-4 sm:py-6">
          <h1 class="text-xl sm:text-3xl font-bold text-gray-900">Admin Dashboard</h1>
          <button
            @click="handleLogout"
            class="inline-flex shrink-0 items-center px-3 py-2 sm:px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Abmelden
          </button>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 sm:py-8">
      <div class="bg-white shadow sm:rounded-lg">
        <div class="border-b border-gray-200">
          <nav class="-mb-px flex gap-6 overflow-x-auto [scrollbar-width:none] px-4 sm:gap-8 sm:px-6" aria-label="Tabs">
            <button
              v-for="tab in tabs"
              :key="tab.id"
              @click="activeTab = tab.id"
              :class="[
                activeTab === tab.id
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
              ]"
            >
              {{ tab.name }}
            </button>
          </nav>
        </div>

        <div class="p-4 sm:p-6">
          <MemberAdmin v-if="activeTab === 'members'" />
          <PunishmentAdmin v-if="activeTab === 'punishments'" />
          <MemberPunishmentAdmin v-if="activeTab === 'member-punishments'" />
          <PresenceAdmin v-if="activeTab === 'presences'" />
          <SubsidyAdmin v-if="activeTab === 'subsidies'" />
          <RuleAdmin v-if="activeTab === 'rules'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import authService from '@/services/AuthService'
import MemberAdmin from '@/components/admin/MemberAdmin.vue'
import PunishmentAdmin from '@/components/admin/PunishmentAdmin.vue'
import MemberPunishmentAdmin from '@/components/admin/MemberPunishmentAdmin.vue'
import PresenceAdmin from '@/components/admin/PresenceAdmin.vue'
import SubsidyAdmin from '@/components/admin/SubsidyAdmin.vue'
import RuleAdmin from '@/components/admin/RuleAdmin.vue'

const router = useRouter()
const activeTab = ref('members')

const tabs = [
  { id: 'members', name: 'Mitglieder' },
  { id: 'punishments', name: 'Strafen' },
  { id: 'member-punishments', name: 'Mitgliedsstrafen' },
  { id: 'presences', name: 'Anwesenheiten' },
  { id: 'subsidies', name: 'Subventionen' },
  { id: 'rules', name: 'Regeln' }
]

const handleLogout = () => {
  authService.logout()
  router.push({ name: 'admin-login' })
}
</script>

